import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService, AppDataSharingService } from '@pulse/common';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'no-loader': 'yes'
  })
};
@Injectable({
  providedIn: 'root'
})
export class PropertiesDocumentsService {
  getDataByNicknameAPI = 'document/GetDocumentDataByNickname';
  getWebReportForAddTenantToPropertyAPI =
    'document/GetWebReportForAddTenantToProperty';
  UpdateCategoriesByNodeId = 'Documents/UpdateCategoriesByNodeId';
  UpdateCategoriesByNicknames = 'document/AssignPropertyGroups';
  addOrRemovePropertyFavoriteAPI = 'document/AddOrRemovePropertyFavoriteWebReport'
  fetchNodeInfoOfSubfolderWebReport = 'document/fetchNodeInfoOfSubfolderWebReport';

  constructor(private http: HttpClient, private config: AppConfigService, private appDataSharingService: AppDataSharingService,) { }

  getPOCDocs(nodeId, pageNum) {
    if(!nodeId) {
      nodeId = '413359'
    }
    let url = `${this.config.get('content_server_api_v2')}/app/container/${nodeId}?fields=sharing_info&fields=rmiconsdata&fields=followups&fields=signature_info&fields=external_source&fields=bwsinfo%7Bup%7D&limit=100&page=${pageNum}&sort=asc_name`
    let config = {
      headers: {
        otcsticket: this.appDataSharingService.getOtcsTicket(),
        'no-loader': 'true'
      }
    }
    return this.http.get<any>(url, config);
  }

  favoriteDocument(doc) {
    let config = {
      headers: {
        OTDSTicket: this.appDataSharingService.getOtdsTicket(),
        'no-loader': 'true'
      }
    }
    return this.http.post<any>(`${this.config.get('content_server_api_v2')}members/favorites/${doc.id}`, {name: doc.name}, config);
  }

  unFavoriteDocument(doc) {
    let config = {
      headers: {
        OTDSTicket: this.appDataSharingService.getOtdsTicket(),
        'no-loader': 'true'
      }
    }
    return this.http.delete<any>(`${this.config.get('content_server_api_v2')}members/favorites/${doc.id}`, config);
  }

  uploadFiles(file: File, doc, type): Observable<any> {
    const formData: FormData = new FormData();
    
    formData.append('file', file, file.name);
    const body = {
      name: file.name,
      type: type,
      parent_id: doc.id
      //external_modify_date: this.dateUtil.toLocalString(new Date())
    }
    //const boundary = '----WebKitFormBoundary' + Math.random().toString(36).substring(2);
    formData.append('body', JSON.stringify(body));
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'OTDSTicket': this.appDataSharingService.getOtdsTicket()
    });

    return this.http.post(`${this.config.get('content_server_url')}/nodes`, formData, { headers });
  }

  addFolder(doc, parentId): Observable<any> {
    const formData: FormData = new FormData();

    const body = {
      type: doc.type,
      type_name: doc.type == 0 ? "Folder" : "Collection",
      container: true,
      name: doc.name,
      parent_id: parentId,
      inactive: true
    }
    //const boundary = '----WebKitFormBoundary' + Math.random().toString(36).substring(2);
    formData.append('body', JSON.stringify(body));
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'OtcsTicket': this.appDataSharingService.getOtcsTicket()
    });

    return this.http.post(`${this.config.get('content_server_url')}/nodes`, formData, { headers });
  }

  fileValidation(files, doc): Observable<any> {
    const fileNameArr = files.map(file => file.name);
    const formData: FormData = new FormData();
    const body =  {parent_id: doc.id, names: fileNameArr};
    formData.append('body', JSON.stringify(body));
    const headers = new HttpHeaders({
      'content-type': 'application/x-www-form-urlencoded',
      'OtcsTicket': this.appDataSharingService.getOtcsTicket()
    });
    
    return this.http.post(`${this.config.get('content_server_api_v2')}validation/nodes`, formData, {headers})
  }

  getPropertyCSNodeId(postBody): Observable<any> {
    let url = `${this.config.getApi('globalDocumentsAPI')}${this.getDataByNicknameAPI
      }`;

    return this.http.post<any>(url, postBody);
  }

  getWebReportForAddTenantToProperty(postBody): Observable<string> {
    const url = `${this.config.getApi('globalDocumentsAPI')}${this.getWebReportForAddTenantToPropertyAPI}`;
    return this.http.post<string>(url, postBody);
  }

  updateCategoriesByNodeId(postBody): Observable<string> {
    const url = `${this.config.getApi('documentsAPI')}${this.UpdateCategoriesByNodeId
      }`;
    return this.http.post<string>(url, postBody);
  }
  updateCategoriesByNicknames(postBody): Observable<string> {
    const url = `${this.config.getApi('globalDocumentsAPI')}${this.UpdateCategoriesByNicknames
      }`;
    return this.http.post<string>(url, postBody, httpOptions);
  }

  getPropNickName(property) {
    return `AV_${property.id}`;
  }

  getRootFolderNickName() {
    return this.config.get('rootdocNickname'); // `AV_PropertyManagement`;
  }

  addOrRemovePropertyFavorite(postBody): Observable<string> {
    let url = `${this.config.getApi('globalDocumentsAPI')}${this.addOrRemovePropertyFavoriteAPI
      }`;

    return this.http.post<any>(url, postBody, httpOptions);
    }

    fetchNodeOfSubfolderWebReport(postBody:any):Observable<string> {
      let url = `${this.config.getApi('globalDocumentsAPI')}${this.fetchNodeInfoOfSubfolderWebReport}`;
      const config = {
        headers: new HttpHeaders({
          'otdsticket': this.appDataSharingService.getOtdsTicket()
        })
      };
      return this.http.post<any>(url, postBody, config);
    }

    getFolderMetadata(nodeId) {
      let url = `${this.config.get('content_server_url')}/forms/nodes/update?id=${nodeId}`;
      let config = {
        headers: {
          otcsticket: this.appDataSharingService.getOtcsTicket(),
        }
      }
      return this.http.get<any>(url, config);
    }

    // In-memory tree state storage
    private treeStateCache: Map<string, any> = new Map();

    // Folder tree state management methods
    saveFolderTreeState(propertyId: string, treeState: any): void {
      const storageKey = propertyId ? 
        `light-widget-tree-state-${propertyId}` : 
        'light-widget-tree-state-global';
      
      this.treeStateCache.set(storageKey, treeState);
      console.log('Tree state saved to memory for key:', storageKey);
    }

    getFolderTreeState(propertyId: string): any {
      const storageKey = propertyId ? 
        `light-widget-tree-state-${propertyId}` : 
        'light-widget-tree-state-global';
      
      const state = this.treeStateCache.get(storageKey);

      return state || null;
    }

    clearFolderTreeState(propertyId: string): void {
      const storageKey = propertyId ? 
        `light-widget-tree-state-${propertyId}` : 
        'light-widget-tree-state-global';
      
      this.treeStateCache.delete(storageKey);
      console.log('Tree state cleared from memory for key:', storageKey);
    }

    // Clear all tree states (useful for cleanup)
    clearAllTreeStates(): void {
      this.treeStateCache.clear();
      console.log('All tree states cleared from memory');
    }
}
